/**
 * Meadow Inventory Swap
 *
 * Rosewood urn is shown by default. Darkwood is always hidden.
 * If a location is provided and the API reports rosewood is out of
 * stock, rosewood is hidden and darkwood is shown instead.
 */
(function () {
  'use strict';


  var PROXY_BASE = '/apps/meadow';
  var SESSION_KEY_LOCATION = 'meadow_location';

  var ROSEWOOD_URN = '8415940772012';
  var DARKWOOD_URN = '8512521076908';

  // Hide darkwood immediately so it never flashes.
  // Target both the grid item parent (collapses the slot) and the card-wrapper.
  var hideDarkwoodStyle = document.createElement('style');
  hideDarkwoodStyle.textContent =
    '.grid__item:has(> .card-wrapper[data-product-id="' + DARKWOOD_URN + '"]) { display: none !important; }' +
    ' .card-wrapper[data-product-id="' + DARKWOOD_URN + '"] { display: none !important; }';
  document.head.appendChild(hideDarkwoodStyle);

  function getLocation() {
    var params = new URLSearchParams(window.location.search);
    var location = params.get('location') || sessionStorage.getItem(SESSION_KEY_LOCATION);
    if (params.get('location')) {
      sessionStorage.setItem(SESSION_KEY_LOCATION, params.get('location'));
    }
    return location;
  }

  function setProductVisible(productId, visible) {
    var cards = document.querySelectorAll('.card-wrapper[data-product-id="' + productId + '"]');
    for (var i = 0; i < cards.length; i++) {
      var el = cards[i].closest('.grid__item') || cards[i];
      el.style.display = visible ? '' : 'none';
      // Our CSS hides darkwood before Dawn's scroll-animation observer runs,
      // so the observer marks it offscreen (opacity: 0.01). Cancel the
      // animation on show so the card is immediately visible.
      if (visible && el.classList.contains('scroll-trigger')) {
        el.classList.remove('scroll-trigger--offscreen');
        el.classList.add('scroll-trigger--cancel');
      }
    }
  }

  async function init() {
    var location = getLocation();
    if (!location) return;

    try {
      var response = await fetch(
        PROXY_BASE + '/products?location=' + encodeURIComponent(location)
      );
      if (!response.ok) {
        console.error('[meadow-swap] Proxy request failed:', response.status);
        return;
      }
      var data = await response.json();
      if (!data || !data.products) return;

      // The API returns darkwood with swapped_from set when rosewood is out of stock.
      // If no product has swapped_from pointing to rosewood, rosewood is in stock — keep defaults.
      var swappedProduct = null;
      for (var i = 0; i < data.products.length; i++) {
        var swappedFrom = data.products[i].swapped_from;
        if (swappedFrom && swappedFrom.split('/').pop() === ROSEWOOD_URN) {
          swappedProduct = data.products[i];
          break;
        }
      }

      if (!swappedProduct) return;

      // Rosewood out of stock — remove the CSS hiding darkwood, then swap visibility
      hideDarkwoodStyle.parentNode.removeChild(hideDarkwoodStyle);
      setProductVisible(ROSEWOOD_URN, false);
      setProductVisible(DARKWOOD_URN, true);

      // If on the Rosewood product detail page, redirect to Darkwood
      if (document.querySelector('product-info[data-product-id="' + ROSEWOOD_URN + '"]')) {
        var redirectUrl = '/products/' + swappedProduct.handle;
        if (location) redirectUrl += '?location=' + encodeURIComponent(location);
        window.location.replace(redirectUrl);
      }
    } catch (err) {
      console.error('[meadow-swap] Error:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
